export default __webpack_public_path__ + "static/media/test2.84d0a99b.png";